import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthCheckSpinner from "./AuthCheckSpinner";

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return <AuthCheckSpinner />;
  }

  if (!isAuthenticated) {
    // Redirect to login, and remember where the student was
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />; // Allow access to the child routes
};

export default ProtectedRoute;
